<template>
  <div v-if="isHelpDetail" class="card-item relative">
    <nuxt-link :to="urls">
      <div class="flex-y-center gap-[10px]">
        <div>
          <Resource
            :src="item.cover_url"
            :transform-resource="transformImage"
            class="w-[30px] h-[30px] rounded-full"
          />
        </div>
        <div
          class="truncate text-16 font-semibold text-font-1 hover:text-primary"
        >
          <span class="truncate">{{ item.title }}</span>
        </div>
        <NewTag v-if="item.is_new" class="-ml-[6px]"></NewTag>
      </div>
      <a-divider class="divider-line mt-[13px] mb-[2px]" />
      <div class="list flex flex-col pl-[10px]">
        <nuxt-link
          v-for="detail in item?.documents?.slice(0, 4)"
          :key="detail.id"
          class="item"
          :to="{
            name: PageKey.HELP_CENTER_DETAIL,
            params: {
              id: `${item.id}${detail.id ? `-${detail.id}` : ''}`,
            },
          }"
        >
          {{ detail.name }}
        </nuxt-link>
      </div>
      <div class="absolute bottom-[24px] pl-[10px]">
        <span class="text-font-60 hover:text-font-1 text-14 flex-y-center">
          {{ $t('cha-kan-geng-duo') }}
          <iconpark-icon name="arrowright"></iconpark-icon>
        </span>
      </div>
    </nuxt-link>
  </div>
  <div v-else class="card-item-cover">
    <nuxt-link :to="urls">
      <Resource
        :src="item.cover_url"
        :transform-resource="transformImage"
        class="w-full h-full absolute left-0 top-0 z-0"
      />
      <div class="relative z-1">
        <div class="flex-y-center gap-[5px]">
          <div
            class="truncate text-[20px] font-semibold text-[var(--help-text-color)]"
          >
            <span class="truncate">{{ item.title }} </span>
          </div>
          <NewTag v-if="item.is_new"></NewTag>
        </div>
        <div
          class="text-[var(--help-text-color)] text-14 mt-[20px] leading-[24px] font-semibold"
        >
          {{ item.description }}
        </div>
        <div class="mt-[30px]">
          <a-button class="btns font-semibold">
            {{ $t('li-ji-cha-kan') }}
          </a-button>
        </div>
      </div>
    </nuxt-link>
  </div>
</template>

<script lang="ts" setup>
import { type IHelpCategory } from '~/api/index'
import { PageKey } from '~/constants/page'

const { $t } = useNuxtApp()

const props = defineProps<{
  item: IHelpCategory
}>()

const isHelpDetail = computed(() => !props.item.jump_url)

const urls = computed(() => {
  if (props.item?.jump_url) {
    return { path: props.item.jump_url }
  }

  if (props.item.id) {
    return {
      name: PageKey.HELP_CENTER_DETAIL,
      params: {
        id: props.item.id,
      },
    }
  }
})
</script>

<style lang="scss" scoped>
.card-item {
  @apply p-[24px] h-[293px] w-[268px] rounded-[12px] overflow-hidden cursor-pointer;
  border: 1px solid var(--back-5);
  .divider-line {
    border-top: 1px solid var(--back-5);
  }
  .list {
    .item {
      @apply text-font-1 text-12 mt-[18px] relative pl-[16px] truncate font-semibold;
      &:before {
        @apply rounded-full absolute left-[0px] top-[50%] transform translate-y-[-50%];
        content: '';
        height: 4px;
        width: 4px;
        background: var(--text-1);
      }
      &:hover {
        @apply text-primary;
        &:before {
          background: var(--purple-6);
        }
      }
    }
  }
}
.card-item-cover {
  @apply w-[268px] h-[293px] p-[33px_29px] rounded-[12px] overflow-hidden cursor-pointer relative;
  .btns {
    @apply rounded-[18px] text-[14px] min-w-[120px] h-[36px];
    border-color: var(--help-text-color);
    color: var(--help-text-color);
    background: transparent;
  }
}
</style>
